//import Dexie from 'dexie';
//import { Observable } from 'rxjs/Observable';
//import { when } from 'q';
//import { getLocaleFirstDayOfWeek } from '@angular/common';

export const enum SoortStemming {
    GeenStemming=0,
    GewoneStemming=1,
    GeheimeStemming=2
}

export interface IZittingGroupByDb {
    Id:number;
    GroupByIds:number[];
}

export interface IZittingDb {
    Id:number;
    SoortZitting:string;
    SoortZittingId:number;
    DatumZitting:string|Date;
    StandpuntToegelaten:boolean;
    Plaats: string;
    Uur: string;
    NotificatieVerstuurd:boolean;
    AantalLeden:number;
    AantalOngelezenNotities:number;
    IsAfwezig:boolean;
    OnbepaaldIsBespreken:boolean;
    IsActiefLid:boolean;
    //GroupByColumnIds:number[];
}

export interface ISubpuntDb {
    Id:number;
    Volgnumer:string;
    Titel:string;
    StandpuntAanvaard:number;
    StandpuntBespreken:number;
    StandpuntToegelaten:boolean;
}

export interface IAgendapuntDb {
    Id:number;
    ZittingId:number;
    SoortZitting:string;
    DatumZitting:Date|string;    
    Titel:string;
    Volgnummer:string;
    Classificatie:string;
    Indeling:string;
    SoortPunt:string;
    BevoegdPersoon:string;
    Hoofdrubriek:string;
    Nevenrubriek:string;
    AantalLeden:number;
    MijnStandpunt:number; // standpuntstatus
    Dienst:string;
    AantalNotities?:number;
    HasCurrentUserStemrecht:boolean;
    HasCurrentUserNotitieRecht:boolean;
    Favoriet:boolean;
    BladwijzerId?:number;
    HeeftSubPunten:boolean;
    HeeftGerelateerdePunten:boolean;
    SubpuntenZijnOpties:boolean;
    SoortStemming:SoortStemming;
    StandpuntToegelaten:boolean;
    AlgemeenStandpuntWeergeven:boolean;
    Bespreken:boolean;
    BesprekenOmschrijving:string;
    IsLoaded?:boolean;
  AantalGekoppeldeDossiers: number;
}

export interface IDossierDb {
    SoortDossierId : number;
    DossierId : string;
    SoortDossier : string;
  SoortDossierCode: string;
    UrlTemplate : string;
}

export interface IDetailAgendapuntDb {
    Subpunten:ISubpuntDb[];
    Documenten:IDocumentDb[];
    GekoppeldePunten:IReferencedPuntDb[];
    Notities:INotitieDb[];
    Dossiers:IDossierDb[];
    StreamingLink:string;
}

export interface IReferencedPuntDb {
    Id:number;
    ZittingId:number;
    RelatedPuntId:number;
    Titel:string;
}

// export interface IDetailAgendapuntDb {
//     Id:number;
//     Subpunten:ISubpuntDb[];
//     GekoppeldePunten:IReferencedPuntDb[];
//     Documenten:IDocumentDb[];
//     Notities:INotitieDb[];
// }

export interface ISubpuntDb {
    Id:number;
    AgendapuntId:number;
    Volgnummer:string;
    Titel:string;
}

export interface IDocumentDb {
    Id: number;
    DatumUpdate: Date | string;
    Titel: string;
    AgendapuntId?: number;
    DateRange:number;
    ZittingId?: number;
    //Extension:string;
    Verwijzing:string;
}

export interface IBladwijzerDb {
    Id:number;
    ZittingId:number;
    AgendapuntId:number;
    DatumZitting:Date|string;
    SoortZitting:string;
    Titel:string;
    DatumUpdate:Date|string;
    AtHomeColorClass:string;
}

export interface INotitieDb {
    Id:number;
    NotitieId:number;
    AgendapuntId:number;
    ZittingId:number;
    Inhoud:string;
    PersoonId:number;
    PersoonNaam: string;
    Persoonlijk:boolean;
    Status:number;
    DatumUpdate: string | Date;
    AantalPersonen:number;    
    Afzender?:string;
}
export interface IPrikbordItemDb {
    Id:number;
    Soort:string;
    Titel:string;
    DatumUpdate:Date | string;
    Url?:string;
    Content?:string;
    HasBijlage?:boolean;
    BijlageTitel:string;
  Ext?: string;
  }

// class CobraDb extends Dexie  { 

//     cacheTimes: Map<string, Date>;
//     zittingGroupByIds:Dexie.Table<IZittingGroupByDb,number>;
//     zittingen:Dexie.Table<IZittingDb,number>;
//     agendapunten:Dexie.Table<IAgendapuntDb,number>;
//     detailagendapunten:Dexie.Table<IDetailAgendapuntDb,number>;
//     documenten:Dexie.Table<IDocumentDb,number>;
//     bladwijzers:Dexie.Table<IBladwijzerDb,number>;
//     subpunten:Dexie.Table<ISubpuntDb,number>;
//     notities:Dexie.Table<INotitieDb,number>;
//     prikborditems:Dexie.Table<IPrikbordItemDb,number>;
//     gekoppeldepunten:Dexie.Table<IReferencedPuntDb,number>;

//     constructor( ) {
//         super("CobraDb");
//         this.version(1).stores({
//             zittingGroupByIds:'&Id,DatumZitting',
//             zittingen:'&Id',
//             agendapunten:'&Id, ZittingId',
//             documenten:'&Id,DateRange,AgendapuntId,ZittingId',
//             bladwijzers:'&Id',
//             subpunten:'&Id,AgendapuntId',
//             notities:'&Id,AgendapuntId,DatumUpdate',
//             prikborditems:'&Id',
//             gekoppeldepunten:'&Id,AgendapuntId'
//         });
//         this.cacheTimes = new Map<string,Date>();
//     }

//     retrieveTimeCached<T,Tid>(fromTable:Dexie.Table<T,Tid>, query : Dexie.Collection<T,Tid>, whenNotExits:Observable<T[]>,refreshAfter:number) {
//         const lastTime = this.cacheTimes.get(fromTable.name) || new Date(1900,0,1);
//         const now = new Date();
//         const force = (now.getTime() - lastTime.getTime()) > refreshAfter;
//         if (force) {this.cacheTimes.set(fromTable.name,now);}
//         return this.retrieve(fromTable,query,whenNotExits,force);
//     }

//     single<T,TId>(fromTable:Dexie.Table<T,TId>,query:Dexie.Collection<T,TId>,whenNotExits:Observable<T>) {
//         return query.first().then(result=>result ? Promise.resolve(result) : whenNotExits.toPromise());
//     }

//     retrieve<T,Tid>(fromTable:Dexie.Table<T,Tid>, query : Dexie.Collection<T,Tid>, whenNotExits:Observable<T[]>,force:boolean=false) {
//         const result= cobraDb.transaction('rw',fromTable,()=>{
//             if (force) {
//                 return query.delete().then(_=>Promise.resolve([] as T[]));
//             }
//             return query.toArray();
//         }).then(results=>{
//             if (results.length>0) {return Promise.resolve(results);}
//             return whenNotExits.toPromise().then(results=>{
//                 if (!results) {return [];}
//                 return fromTable.bulkAdd(results).then(_=>results);
//             });
//         })
//         //result.catch(err=>window.alert(err));
//         return result;
//     }

//     clearCache<T,Tid>(fromTable:Dexie.Table<T,Tid>){
//         this.cacheTimes.delete(fromTable.name);
//     }
//     retrieveSpecial<T>(multiQuery:IMultiQuery<T>) {
//         // if force delete all entries or update?
//         // count isCacheCheck query
//         // if (count>0) perform all queries and return result
//         // perform whenNotExists 
//         // update each table
//         // all results should be Observable<T>
//         let resolveShouldLoad : Promise<boolean>;
//         if (multiQuery.getShouldLoad) { 
//             resolveShouldLoad=multiQuery.getShouldLoad;
//         } else {
//             resolveShouldLoad=multiQuery.queries.find(q=>q.isCacheCheck).query.count().then(count=>count===0); 
//         }
//         var resultP = resolveShouldLoad.then(shouldLoad => shouldLoad ?  this.executeRequest(multiQuery) : this.executeQueries(multiQuery));
//         return resultP;
//     }
//     executeQueries<TResult>(multiQuery:IMultiQuery<TResult>){
//         return Promise.all(multiQuery.queries.map(q=>{q.result=q.query.toArray();return q.result;}))
//         .then(results=>results.forEach((r,index)=>multiQuery.queries[index].dbToResult(r)))
//         .then(_=>multiQuery.result);
//     }
//     executeRequest<TResult>(multiQuery:IMultiQuery<TResult>):Promise<TResult> {
//         let requestP=multiQuery.whenNotFound.toPromise();
//         return requestP.then(requestResult=>{
//             return cobraDb.transaction('rw',multiQuery.queries.map(q=>q.fromTable),()=>{
//                 return Promise.all(multiQuery.queries.map(q=>q.fromTable.bulkPut(q.requestToDb(requestResult))));
//             }).then(_=>requestResult);
//         });
//     }
// }

// export interface IMultiQuery<TResult> {
//     result?:TResult;
//     queries:IQuery<any,any,TResult>[];
//     whenNotFound:Observable<TResult>;
//     getShouldLoad?:Promise<boolean>;
//     force:boolean;
//     isLoaded?:boolean;
// }

// interface IQuery<T,TId,TResult> {
//     fromTable:Dexie.Table<T,TId>;
//     query:Dexie.Collection<T,TId>;
//     isMain?:boolean;
//     isCacheCheck?:boolean;
//     result?:Promise<any[]>;
//     dbToResult:(result:any[])=>void;
//     requestToDb:(requestResult:TResult)=>any[];
// }

//sexport const cobraDb  = new CobraDb();
export const defaultCacheTime = 300000;
